/**
 * a function to change page title during
 * run time from react code
 */
export default function setTitle(title) {
    if (typeof title !== "string") {
       throw new Error("Title should be an string");
    }
    document.title = title;
  }
  